export type NOTIFICATION_APPEARANCE = "error" | "info" | "success" | "warning";

export enum NOTIFICATION_TYPE {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
}

export interface Notification {
  message: string;
  appearance: NOTIFICATION_APPEARANCE;
}
